export default __webpack_public_path__ + "static/media/s2.e8b9e358.svg";